import React from "react";
import Social from "../components/Social";
import Typography from '@mui/material/Typography';
import { makeStyles, ThemeProvider } from '@mui/styles';
import { createTheme, responsiveFontSizes, StyledEngineProvider } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import {globalTheme} from "../components/Theme"
import {homeBackground} from '../assets'
import ReactPlayer from 'react-player/lazy'

const useStyles = makeStyles((theme) => ({
    root: {
        overflow: "hidden",
    },
    homeContent: {
        paddingTop: theme.spacing(5),
    },
    player: {
        position: "fixed",
        minWidth: "100%",
        minHeight: "56.25vw",
        opacity: 0.1,
        top: "62.5%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    },
    desc: {
        margin: "0 20px 0 20px"
    }
}))

let theme = createTheme({
    typography: {
        h1: {
            fontWeight: 600, 
        },
        h6: {
            fontFamily: "Raleway",
        }
    },
}, globalTheme);
theme = responsiveFontSizes(theme);

export default function Home() {
    const classes = useStyles(globalTheme);

    return (
        (<div className={classes.root}>
            <ReactPlayer 
                className={"homeBackground " + classes.player}
                url={[homeBackground]}
                width='177.77777778vh'
                height='100%'
                muted
                config={{
                    youtube: {
                    playerVars: { autoplay: 0 }
                    },
                    file: {
                        attributes: {
                            autoPlay:true,
                            loop: true,
                            playsInline: true
                        }
                    }
                }}
            />
            <Grid 
                container
                className={"content " + classes.homeContent}
                direction="column"
                alignItems="center"
                justifyContent="center"
            >
                <Grid item xs>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={theme}>
                            <Typography variant="h1" align="center" style={globalTheme.palette.heading}>
                                Hello!
                            </Typography>
                            <Typography variant="h6" align="center" paragraph className={classes.desc}>
                                Welcome to my website! <br></br> 
                                I'm a software developer with experience in full-stack, application, and game development. <br></br>
                                I also have an interest in music production and CGI. <br></br>
                                You can take a look at my work in the projects page.
                            </Typography>
                        </ThemeProvider>
                    </StyledEngineProvider>
                </Grid>

                <Grid item>
                    <div className='social'>
                        <Social />
                    </div>
                </Grid>
            </Grid>
        </div>)
    );
}
